"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));
/**
 * Function to get current time with default format `MM/DD/YYYY HH:mm:ss`
 * For format, you can refer the `dayjs` docs
 *
 * @param {string} format
 * @returns {string}
 */


function getTimeNow(format) {
  if (format === void 0) {
    format = 'MM/DD/YYYY HH:mm:ss';
  }

  return "".concat((0, dayjs_1.default)(new Date()).format(format));
}

exports.default = getTimeNow;